import styled from "styled-components";
import {
	TABLET_BP,
	COLOR_BORDER_GREY,
	COLOR_LIGHT_GREY,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_TEXT_HIGHLIGHT,
	COLOR_LINKEDIN_BLUE,
	COLOR_FACEBOOK_BLUE,
} from "@website-builder/utilities-index";

export const ReferrerContainer = styled.div`
	.modal {
		padding: 0;
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		.modal {
			top: 0;
			left: 0;
			transform: unset;
			width: 100%;
			height: 100vh;
		}
	}
`;

export const ReferrerModalWrapper = styled.div`
	width: 950px;
	box-sizing: border-box;
	.banner {
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 15px;
		border-bottom: 1px solid ${COLOR_BORDER_GREY};
		background-color: ${COLOR_LIGHT_GREY};
		.imageWrapper {
			text-align: center;
			img {
				height: 190px;
			}
		}
		.header {
			font-size: 24px;
			letter-spacing: 0.6px;
			margin: 20px auto;
			text-align: center;
		}
		.description {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 1.69;
			letter-spacing: 0.6px;
			margin-bottom: 32px;
			max-width: 550px;
			margin-left: auto;
			margin-right: auto;
			text-align: center;
			.amount {
				color: ${COLOR_TEXT_HIGHLIGHT};
			}
		}
	}
	.modalBody {
		max-width: 600px;
		margin-left: auto;
		margin-right: auto;
		padding: 10px 10px 40px 10px;
		.referrerLinkWrapper {
			margin-top: 20px;
			.label {
				margin: 0 0 10px 0;
				font-size: 16px;
				font-weight: ${FONT_WT_LIGHT};
				line-height: 27px;
				text-align: left;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				font-size: 13px;
			}
			.referrerLink {
				border: 1px solid ${COLOR_BORDER_GREY};
				display: flex;
				justify-content: space-between;
				border-radius: 3px;
				.link {
					display: inline-block;
					line-height: 40px;
					padding-left: 10px;
					width: 100%;
					border: none;
					color: transparent;
					text-shadow: 0 0 0 ${COLOR_TEXT_HIGHLIGHT};
					&:focus {
						outline: none;
					}
				}
				.copyButton {
					display: inline-flex;
					cursor: pointer;
					align-items: center;
					img {
						height: 16px;
						margin-right: 8px;
					}
					background-color: ${COLOR_LIGHT_GREY};
					line-height: 40px;
					padding: 0 10px;
					border-left: 1px solid ${COLOR_BORDER_GREY};
					color: ${COLOR_TEXT_PRIMARY_B2C};
				}
			}
		}
		.socialCTAWrapper {
			margin-top: 24px;
			display: flex;
			justify-content: space-between;
			.socialCTA {
				cursor: pointer;
				padding-left: 10px;
				border-radius: 3px;
				text-decoration: none;
				&.facebook {
					background: ${COLOR_FACEBOOK_BLUE};
					img {
						margin-bottom: 5px;
						height: 22px;
					}
				}
				&.linkedin {
					background: ${COLOR_LINKEDIN_BLUE};
					img {
						margin-bottom: 4px;
					}
				}
				&.mail {
					background: ${COLOR_TEXT_PRIMARY_B2C};
				}
				height: 45px;
				width: 170px;
				display: inline-flex;
				align-items: center;
				color: white;
				img {
					height: 25px;
					display: inline-block;
					margin-right: 10px;
				}
			}
		}
		.footerLink {
			text-align: center;
			margin-top: 32px;
			a {
				text-decoration: underline;
				color: ${COLOR_LINKEDIN_BLUE};
			}
			letter-spacing: 0.7px;
		}
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		width: 100%;
	}

	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		.modalBody {
			.socialCTAWrapper {
				display: block;
				.socialCTA {
					width: 100%;
					margin-bottom: 20px;
					height: 50px;
					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}
	}
`;
